// extracted by extract-css-chunks-webpack-plugin
module.exports = {"saved-items-page":"saved-items-page___h25N7","title":"title___WZgDj","grid":"grid___F3y01","heart":"heart___vCsZc","startSearch":"startSearch___jRQnp"};